import React from 'react';
import { Sec, SH } from '../components/Section';
import { C } from '../constants';
import { useTheme } from '../contexts/ThemeContext';
import { DecXEngineAnimation } from '../components/DecXEngineAnimation';

export const ScoringWidget = () => {
  const { theme } = useTheme();

  return (
    <Sec id="scoring" dark={theme === 'light'}>
      <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
        <SH
          eyebrow="THE FRAMEWORK"
          title="The DecX Score"
          subtitle="DecX = Decision Likelihood Index. We score what drives real decisions."
          center
        />

        {/* Interactive Animation Diagram */}
        <DecXEngineAnimation />
      </div>
    </Sec>
  );
};
